export enum EInvoiceStatusEnum {
    None = 0,
    Disabled = 1,
    DeactivationPending = 2,
    ActivationPending = 3,
    Enabled = 4
}